<template>
  <v-container fluid class="price-list mt-3">
    <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" md="6" class="d-flex justify-space-between justify-md-start">
              <v-btn to="/price/add" color="success" class="button-shadow mr-3">
                <v-icon class="mr-2">mdi-plus</v-icon>
                Add
              </v-btn>
              <v-btn color="primary" outlined class="button-shadow">
                <v-icon class="mr-2">mdi-filter-variant</v-icon>
                Filters
              </v-btn>
            </v-col>
            <v-col cols="12" md="6" class="d-flex justify-end mt-3 mt-md-0">
                <div :style="$vuetify.breakpoint.smAndDown ? 'width: 100%' : 'width: 250px'">
                <v-text-field
                  dense
                  :full-width=$vuetify.breakpoint.smAndDown
                  outlined
                  hide-details
                  label="Search"
                  prepend-inner-icon="mdi-magnify"
                ></v-text-field>
              </div>
            </v-col>
            <v-col cols="12" class="d-flex justify-end mt-3">

            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="ma-1">
          <v-card-text>
            <v-data-table
              :loading="isReceiving || isDeleting"
              loading-text="Loading... Please wait"
              class="prices-table"
              show-select
              single-select
              item-key="_id"
              sort-by="createdAt"
              :footer-props="footer"
              :headers="headers"
              :items="prices"

              :items-per-page="itemPerPage">
              <template v-slot:top>
                <v-dialog
                  v-model="dialog"
                  width="500"
                >
                  <v-card>
                    <v-card-title>
                      Delete this Price?
                    </v-card-title>

                    <v-card-text>
                      {{ deleteprice.pricelistname }}: {{ deleteprice.pricename }} - {{ deleteprice.itemname }}
                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" outlined @click="dialog = false">Cancel</v-btn>
                      <v-btn color="secondary" class="button-shadow" @click="deleteItem(deleteprice)">Delete</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </template>
              <template v-slot:item.pricelistid="{ item }">
                <p class="two-line">{{ pricelists.length!==0 ? pricelists.find(pricelist=>pricelist._id == item.pricelistid)['pricelistname'] : ''  }}</p>
                <p class="two-line"><a class="primaryConst--text">{{ item.pricename }}</a></p>
              </template>
              <template v-slot:item.itemid="{ item }">
                {{ items.length!==0 ? items.find(i=>i._id == item.itemid)['itemname'] : ''  }}
              </template>
              <template v-slot:item.minqty="{ item }">
                <p class="two-line">{{ item.minqty }}</p>
                <p class="two-line">{{ item.maxqty  }}</p>
              </template>
              <template v-slot:item.createdAt="{ item }">
                {{ new Date(item.createdAt).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}
              </template>
              <template v-slot:item.actions="{ item }">
                <v-btn icon color="primary" @click="editItem(item)">
                  <v-icon>mdi-pencil-outline</v-icon>
                </v-btn>
                <v-btn icon color="primary" @click="deleteDialog(item)">
                  <v-icon>mdi-delete-outline</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import mock from "./mock"
import config from "../../../config"
import { mapState, mapActions } from 'vuex'

export default {
  name: 'PriceList',
  data() {
    return {
      mock,
      config,
      snackbar: null,
      dialog: false,
      deleteprice: {},
      headers: [
        { text: 'Price List', value: 'pricelistid', sortable: false },
        { text: 'Item', value: 'itemid' },
        { text: 'Min Max Qty', value: 'minqty' },
        { text: 'Price', value: 'listprice' },
        { text: 'Create', value: 'createdAt' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      footer: {'items-per-page-options': [100, 500, 1000, 5000]},
      itemPerPage: 100,
      selected: [],
      switch1: true,
    }
  },

  computed: {
    ...mapState('Price', ['prices', 'isReceiving', 'isDeleting', 'idToDelete', 'pricesMessage', 'isUpdating']),
    ...mapState('PriceList', ['pricelists']),
    ...mapState('Item', ['items']),
  },
  mounted(){
    this.getPricesRequest();
    if(this.items.length == 0) this.getItemsRequest();
    if(this.pricelists.length == 0) this.getPriceListsRequest();
    console.log(this.items);
  },
  methods: {
    ...mapActions('Item', ['getItemsRequest']),
    ...mapActions('Price', ["getPricesRequest","deletePriceRequest","updatePriceRequest"]),
    ...mapActions('PriceList', ['getPriceListsRequest']),

    editItem(item) {
      this.$router.push({ name: 'PriceEdit', params: item })
    },

    deleteItem(item) {
      this.deletePriceRequest({_id: item._id});
      this.dialog = false;
    },
    deleteDialog(item) {
      this.dialog = true;
    
      this.deleteprice = {
        _id: item._id,
        pricelistid: item.pricelistid,
        pricelistname: this.pricelists.find(pricelist=>pricelist._id == item.pricelistid)['pricelistname'],
        itemname: this.items.find(i=>i._id == item.itemid)['itemname'], 
        pricename: item.pricename,
      }
    },
  },
}
</script>

<style src="./List.scss" lang="scss"></style>
